<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>Default Permissions</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container container--fluid grid-list-md>
          <v-row justify="center">
            <v-select label="Select a region..."
                      :items="regions"
                      return-object
                      item-text="name"
                      v-model="region"
            ></v-select>

            <v-col cols="12">
              <v-card>
                <v-list v-if="region">
                  <v-list-item
                    v-for="(permission, index) in renderedClientPermissions"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-checkbox @change="tickOrUntickPermission(permission)" v-model="permission.selected"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title>{{permission.display}}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
    import axios from 'axios'

    // @group EditClient
    // Table to edit client pricings on EditClientPage
    export default {
        name: "ClientPermissions",
        props: {
            // Array of permissions of the client
            clientPermissions: Array,
            // Function that toggles dialog in which are the permissions
            toggleDialog: Function,
            // Client_id (number)
            id: Number,
        },
        data() {
            return {
                regions: [{id: 0, name: "Global"}],
                region: {id: 0, name: "Global"},
            }
        },
        methods: {
            tickOrUntickPermission(permission) {
                if (permission.selected) {
                    // Tick
                    axios.post(process.env.API_URL + '/clients/' + this.id + '/regions/' + this.region.id + '/permissions/' + permission.id)
                        .then((response) => {
                        })
                        .catch((response) => {
                            permission.selected = !permission.selected;
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    // Untick
                    axios.delete(process.env.API_URL + '/clients/' + this.id + '/regions/' + this.region.id + '/permissions/' + permission.id)
                        .then((response) => {
                        })
                        .catch((response) => {
                            permission.selected = !permission.selected;
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                }
            }
        },
        computed: {
            // @vuese
            // Rendered permissions array that will be displayed in the list
            // @type Array
            renderedClientPermissions() {
                if (this.allPermissions === undefined || this.allPermissions === null) return [];
                return Object.values(this.allPermissions.map((item) => {
                    item.selected = this.clientPermissions.find((el) => {
                        return el.id === item.id;
                    });
                    return item;
                })).sort((a, b) => (a.name > b.name) ? 1 : -1);
            },
        },
        asyncComputed: {
            async allPermissions() {
                return await axios.get(process.env.API_URL + '/users/permissions')
                    .then((response) => {
                        if (response.status === 200) {
                            return response.data;
                        } else return [];
                    })
                    .catch((error) => {
                        return [];
                    });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientPermissions.vue